import { render, staticRenderFns } from "./AudienceSettings.vue?vue&type=template&id=2c293703&scoped=true"
import script from "./AudienceSettings.vue?vue&type=script&lang=ts"
export * from "./AudienceSettings.vue?vue&type=script&lang=ts"
import style0 from "./AudienceSettings.vue?vue&type=style&index=0&id=2c293703&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c293703",
  null
  
)

export default component.exports